<template>
<div>
<flash-message class="myCustomClass"></flash-message>
<v-card-title>
<h2>{{ ctitle }}</h2>
<v-spacer></v-spacer>

  <v-dialog v-model="dialogadd" max-width="800px">
		<template v-slot:activator="{ on }">
		<v-btn v-on="on" color="primary" dark class="mb-2">Add Deferred STARS</v-btn>
		</template>
                <v-card>
                    <v-card-title>
                        <span class="headline">Add Deferred STARS</span>
                    </v-card-title>

                    <div v-if="validationErrors">
                        <ul class="alert alert-danger">
                            <li v-for="(value, key, index) in validationErrors">{{ value }}</li>
                        </ul>
                    </div>

                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>

                                <v-flex>
				   <v-select v-model="addedItem.uin" :items="uin_dropdowns" item-text="key" item-value="value"  prepend-icon="person" label="Student UIN:" dense></v-select> 
                                </v-flex>

                            </v-layout>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" @click="closeadd">Cancel</v-btn>
                        <v-btn color="blue darken-1" @click="store">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>


<v-select label="Select Columns to Display" :items="headers" v-model="filteredheaders" multiple return-object>
        <template v-slot:selection="{ item, index }">
        <v-chip v-if="index === 0">
          <span>{{ item.text }}</span>
        </v-chip>
        <span
          v-if="index === 1"
          class="grey--text caption"
        >(+{{ filteredheaders.length - 1 }} others)</span>
      </template>
        </v-select>
      </v-flex>

<v-btn icon class="mx-0" @click="download">
  <v-icon title="Excel Download" color="green">save_alt</v-icon>
</v-btn>

<v-btn icon class="mx-0" @click="reset">
   <v-icon title="Reload" color="blue">refresh</v-icon>
</v-btn>

<v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>

</v-card-title>   

<v-data-table v-if="isAdmin == 'true'" :footer-props="{'items-per-page-options': [100,200,1000]}" :headers="filteredheaders"
:loading=progress_bar_loading :items="filteredResults" :search="search"
 :options.sync="pagination" class="elevation-1" sort-by="fullname"  multi-sort>




<v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>

<v-alert slot="no-results" :value="true" color="error" icon="warning">Your search for "{{ search }}" found no results.</v-alert>

<template v-slot:item.action="{ item }">
<v-btn icon class="mx-0" @click="deleteItem(item)"><v-icon color="pink">delete</v-icon></v-btn>
</template>

</v-data-table>

</v-card>

</div>
</template>

<script>
import XLSX from 'xlsx';

export default {
	data () {
		return {
isLoading: false,
entries: [],
app_name: process.env.MIX_APP_NAME,
url: '/' + process.env.MIX_APP_NAME,
search: '',
validationErrors: '',
dialogadd: false,
fill:[],
filteredheaders: [],
filteredheaderarray: [],
headerarray:[],
progress_bar_loading: true,
            addedItem: {
		id: '',    
                uin: '',
                created_by: '',
            },
            defaultItem: {
		id: '',    
                uin: '',
                created_by: '',
            },
dialog: false,
		rowsPerPageItems: [10,50,100,2000],
		headers: [
                { text: 'Remove', value: 'action', sortable: true, },
                { text: 'UIN', value: 'uin', sortable: true, },
                { text: 'Student Name', value: 'fullname', sortable: true, },
                { text: 'Created By', value: 'created_by_name', sortable: true, }
		],
		
		filters: {
                fullname:[],
                uin:[],
                created_by_name:[],
		},

		selected:[],
		pagination: {

		},

		Results:[],
	}
	},
	     created () {
		     this.initialize()
	     },
props: {
uin_dropdowns: {
             type: Array,
                   required: true,
                              },
ctitle: {
             type: String,
                   required: true,
                              },
created_by: {
type: String,
      required: true,
     },
isAdmin: {
	      type: String,
	            required: true,
	}
       },

       computed:{
      filteredResults() {
		return this.Results.filter(d => {
			return Object.keys(this.filters).every(f => {
				return this.filters[f].length < 1 || this.filters[f].includes(d[f])
			})
		})
		},
       },

methods:
       {
		columnValueList(val) {
		
			return this.Results.map(d => d[val])
		},

	       mounted() {
	       },
	       initialize()
	       {
		       this.fetchApp()
			this.filteredheaders = this.headers;
	       },
	        close () {
			this.dialog = false
		},
	       async fetchApp(){
		       await axios.get(this.url + '/api/v1/deferredstars')
			       .then((response) => {
					       this.Results = (response.data);
					       this.progress_bar_loading = false;
					       })
		       .catch(error => {});

	       },

               customFilter(crns, search, filter) {
                             search = search.toString().toLowerCase();
                              
                             this.fill = crns.filter(i => (
                                                     Object.keys(i).some(j => filter(i[j], search))
                                                     ))
                                     
                             return this.fill;
                     },
 reset()
                     {
                     this.fetchApp();
                     },
    download() {
      var first_record_json;
      var all_headers;
      var first_record_json;
      var first_record_json_keys;
      var all_headers_not;

      var local_delete = [];

      this.filteredheaders.forEach(element => this.filteredheaderarray.push(element.value));
      this.headers.forEach(element => this.headerarray.push(element.value));
      first_record_json = this.Results[0];

     
      first_record_json_keys  = Object.keys(first_record_json);
      all_headers_not = first_record_json_keys.filter(x=> !this.filteredheaderarray.includes(x));
      
      // local_delete = this.fill;
      local_delete = this.filteredResults; // change this when I figure out how the customFilter should work
    
      for (var k =0;k<local_delete.length;k++)
      {
        for(var i=0;i<all_headers_not.length;i++)
        {
                var key = all_headers_not[i];
                delete local_delete[k][key];
        }
      }
      
      var work = XLSX.utils.json_to_sheet(local_delete);
      var new_workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(new_workbook, work, "SheetJS");
                        var date = new Date();
      XLSX.writeFile(new_workbook, this.app_name + '_app_export_' + date.getTime() + '.xlsx');
                        this.filteredheaderarray = [];
      this.headerarray = [];
    },

    BackgroundColor: function(tcourse, key) {
      var result = '';
     
      if(key == 'approved')
              {
                      if(tcourse.approved == 0)
                      {
                      result = 'badge p-2 h-3 font-weight-light badge-info'
                      }
              else
          {
            result = 'badge p-2 font-weight-light badge-success'
          }
      }

      return result;
    },

closeadd() {
            this.validationErrors = ''
            this.dialogadd = false
            setTimeout(() => {
                this.addedItem = Object.assign({}, this.defaultItem)
                this.addedIndex = -1
            }, 300)
        },
store() {
          
            axios.post(this.url + '/api/v1/deferredstars', {
			uin: this.addedItem.uin,
			created_by: this.created_by
                })
                .then(response => {
                    this.addedItem.id = response.data.id;
                    this.addedItem.uin = response.data.uin;
                    this.Results.push(this.addedItem);
                    
                    this.closeadd()
		    this.reset();
                })
                .catch((error) => {
                    // Error
                   
                    if (error.response) {
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        if (error.response.status == 422) {
                            this.validationErrors = error.response.data.errors;
                        }
                    } else if (error.request) {
                        // The request was made but no response was received
                        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                        // http.ClientRequest in node.js
                       
                    } else {
                        // Something happened in setting up the request that triggered an Error
                         
                    }
                })
        },


BackgroundColor: function(equipment, key) {
    var result = '';

if(key == 'status')
	{
		if(equipment.status.includes('Overdue'))
		{
		result = 'badge p-2 h-3 font-weight-light badge-warning'	
		}
    else if (equipment.status.includes('Due'))
    {
      result = 'badge p-2 h-3 font-weight-light badge-info'
    }
        else 
    {
      result = 'badge p-2 font-weight-light badge-success'
    }
}

    return result;
  },

deleteItem(item) {
            if(confirm('Are you sure you want to delete this item?'))
	    {
            axios.delete(this.url + '/api/v1/deferredstars/' + item.id)
                .then(response => {
                    this.Results.splice(this.filteredResults.indexOf(item), 1);
                })
 	    }
	}
 }
}
</script>
